module.exports = __webpack_public_path__ + "img/Qtrebol.d6296277.png";